import { mapState } from 'vuex'

import fipnum from '../assets/ypitcherFIPsetting.json'

export default {
  data () {
    return {
      resultmax: 20,
      fipnum: fipnum,
      ReadRecord: {
        'G': '試合',
        'AB': '打数',
        'R': '得点',
        'H': '安打',
        'SEC': '二塁',
        'THI': '三塁',
        'HR': '本塁',
        'RBI': '打点',
        'BB': '四球',
        'SO': '三振',
        'SB': '盗塁',
        'CS': '盗死',
        'AVG': '打率',
        'SLG': '長率',
        'OBP': '出率',
        'GS': '先発',
        'CG': '完投',
        'ShO': '完封',
        'W': '勝利',
        'L': '敗戦',
        'IPa': '投球回',
        'IPb': '小数点',
        'ER': '自責',
        'ERA': '防御率',
        'WR': '勝率',
        'SV': 'Ｓ',
        'HLD': 'Ｈ',
        'TBF': '打者',
        'HBP': '死球',
        'DEF': '位置',
        'age': '年齢',
        'hand': '利き腕',
        'heig': '身長',
        'weig': '体重'
      },
      RecList: {
        p: ['id', 'nen', 'team', 'number', 'G', 'GS', 'RC', 'CG', 'ShO', 'FG', 'W', 'L', 'SV', 'HLD', 'IPa', 'IPb', 'TBF', 'AB', 'H', 'HR', 'BB', 'HBP',
          'SO', 'WP', 'R', 'ER', 'ERA', 'JUN', 'DEF', 'r_name', 'age', 'hand'],
        b: ['id', 'nen', 'team', 'number', 'G', 'PA', 'AB', 'R', 'H', 'SEC', 'THI', 'HR', 'RBI',
          'SB', 'CS', 'SH', 'SF', 'BB', 'IBB', 'HBP', 'SO',
          'GDP', 'E', 'AVG', 'JUN', 'OBP', 'SLG', 'OPS', 'DEF', 'r_name', 'age', 'hand']
      }
    }
  },
  computed: {
    PosList () {
      return ['投', '捕', '一', '二', '三', '遊', '外', '指']
    },
    PosNumFlag () {
      return (this.PBcheck === 'b' && (this.Tabselect === 'O'))
    },
    PBcheck () {
      if (this.$route.params.id.toString()[0] === 'p') return 'p'
      else return 'b'
    },
    InputHandList () {
      const hand = {
        b: ['右打', '左打', '両打'],
        p: ['右投', '左投', '両投']
      }
      return hand[this.PBcheck]
    },
    Setubi (r) {
      const s = { heig: 'cm', weig: 'kg' }
      if (s[r] === undefined) {
        return ''
      } else {
        return s[r]
      }
    },
    InputProfile () {
      const yt = this.Yearcheck
      const mode = this.Tabselect
      const list = {
        N: {
          't': [],
          'y': []
        },
        O: {
          't': ['hand'],
          'y': ['hand', 'age']
        }
      }
      return list[mode === 'N' ? 'N' : 'O'][yt]
    },
    InputRecordList () {
      const pb = this.PBcheck
      const mode = this.Tabselect
      const list = {
        N: {
          'b': ['G', 'AB', 'R', 'H', 'SEC', 'THI', 'HR', 'RBI', 'BB', 'SO', 'SB'],
          'p': ['G', 'GS', 'CG', 'ShO', 'W', 'L', 'IPa', 'IPb', 'H', 'BB', 'SO', 'ER']
        },
        O: {
          'b': ['G', 'AB', 'H', 'SEC', 'THI', 'HR', 'BB', 'HBP', 'SO', 'SB', 'CS'],
          'p': ['G', 'GS', 'IPa', 'IPb', 'TBF', 'HR', 'BB', 'HBP', 'SO', 'ER']
        }
      }
      return list[mode === 'N' ? 'N' : 'O'][pb]
    },
    AgeInputFlag () {
      return (this.Tabselect !== 'N' && this.Yearcheck === 'y')
    },
    calcFIP () {
      return function (r, nflag = true) {
        const n = (nflag ? r.nen : '')
        const num = (n in fipnum ? fipnum[n] : 2.85)
        return Math.round(((13 * r.HR + 3 * (r.BB - 0 + r.HBP) - 2 * r.SO) * 3 / (r.IPa * 3 + r.IPb) + num) * 100) / 100
      }
    },
    calcERA () {
      return function (r) {
        return Math.round((r.ER * 9 * 3) / (r.IPa * 3 + r.IPb) * 100) / 100
      }
    },
    arrsum () {
      return function (arr) {
        return arr.reduce(function (prev, current, i, arr) { return prev + current })
      }
    },
    calcWari () {
      return function (a, b) {
        const bunsi = Number(a)
        const bunbo = Number(b)
        if (isNaN(bunsi) || isNaN(bunbo)) return 0
        if (bunbo === 0 && bunsi === 0) return 0
        if (bunbo === 0 && bunsi > 0) return 99999
        return bunsi / bunbo
      }
    },
    Yearcheck () {
      if (this.$route.params.id.toString()[1] === 't') return 't'
      else return 'y'
    },
    ...mapState([
      'suggestionList',
      'users',
      'record',
      'inputedPoss',
      'selectedPoss',
      'targetPos',
      'result_players',
      'Tabselect',
      'targetMatchName'
    ]),
    PrintRecordList () {
      let list = {
        b: ['G', 'AB', 'R', 'H', 'SEC', 'THI', 'HR', 'RBI', 'BB', 'SO', 'SB', 'AVG', 'OBP', 'SLG', 'OPS', 'DEF', 'hand'],
        p: ['G', 'GS', 'CG', 'ShO', 'W', 'L', 'SV', 'HLD', 'WR', 'IPa', 'H', 'HR', 'BB', 'SO', 'ER', 'ERA', 'FIP', 'hand']
      }
      let prlist = list[this.PBcheck]
      if (this.Yearcheck === 'y')prlist.push('age')
      return prlist
    },
    RecordName () {
      return function (r) {
        return (r in this.ReadRecord ? this.ReadRecord[r] : r)
      }
    },
    setWR () {
      return function (w, l) {
        if (w === 0 || l === 0) return 0
        else return Math.round(w / (w + l) * 1000) / 1000
      }
    },
    setERA () {
      return this.calcERA(this.record)
    },
    setAVG () {
      return Math.round((this.record.H) / this.record.AB * 1000) / 1000
    },
    printAVG () {
      const zero = '0000000'
      return function (avg, conm) {
        if (isNaN(avg)) return '.'
        var str = String(Math.round(avg * Math.pow(10, conm)) / Math.pow(10, conm))
        const zflag = (conm === 3)
        if (avg === 0)str = '0.0'
        if (avg < 1.00 && zflag)str = str.slice(1)
        if (str.indexOf('.') === -1 && str.length <= conm)str += '.'
        if (conm - zflag - str.length + 2 > 0)str += zero.slice(0, conm - zflag - str.length + 2)
        return str
      }
    },
    printDEF () {
      return function (def) {
        let posstr = ''
        this.PosList.some(pos => {
          if (def.indexOf(pos) > -1)posstr += pos
        })
        return posstr
      }
    }
  },
  methods: {
    ZeroEx (para) {
      if (para === undefined || para === '') return 0
      return Number(para)
    },
    calcRecord (rname, r) {
      switch (rname) {
        case 'ERA':
          return this.calcERA(r)
        case 'FIP':
          return this.calcFIP(r, false)
        case 'PA':
          return (this.PBcheck === 'p' ? r.TBF : r.AB + r.BB + r.HBP)
        case 'Kpa':
          return this.calcWari(r.SO, this.calcRecord('PA', r))
        case 'HRpa':
          return this.calcWari(r.HR, this.calcRecord('PA', r))
        case 'Bpa':
          return this.calcWari(r.BB, this.calcRecord('PA', r))
        case 'HBPpa':
          return this.calcWari(r.HBP, this.calcRecord('PA', r))
        case 'SBSC':
          return r.SB + r.SC
        case 'WR':
          return this.calcWari(r.W, r.W + r.L)
        case 'SBGO':
          return this.calcWari(r.SB, r.CS)
        case 'ISOP':
          return this.calcRecord('SLG', r) - this.calcRecord('AVG', r)
        case 'SLG':
          return this.calcWari(r.H + r.SEC + r.THI * 2 + r.HR * 3, r.AB)
        case 'AVG':
          return this.calcWari(r.H, r.AB)
        case 'SECpa':
          return this.calcWari(r.SEC + r.THI, r.H)
        case 'GSpa':
          return this.calcWari(r.GS, r.G)
        case 'IP':
          return r.IPa + this.calcWari(r.IPb, 3)
        case 'heig':
          return (r.heig > 0 ? r.heig : 175)
        case 'weig':
          return (r.weig > 0 ? r.weig : 75)
        case 'hand':
          const param = (r.hand.indexOf('左打') > -1) * 1 + (r.hand.indexOf('両打') > -1) * 2 +
          (r.hand.indexOf('左投') > -1) * 3 + (r.hand.indexOf('両投') > -1) * 6
          return param
        default:
          return r[rname]
      }
    },
    RandNameSet () {
      const rec = (this.PBcheck === 'p' ? 'IPa' : 'H')
      const hundred = this.users.filter(p =>
        (this.Yearcheck === 't' || Number(p.nen) > 1960) && (p[rec] >= (this.Yearcheck === 't' ? 150 : 50))
      )
      var player = hundred[parseInt(Math.random() * (hundred.length - 1))]
      this.setID(player.id, player.nen)
      return 1
    },
    setID (inputID, nen) {
      var setplayer = this.users.find((p) => {
        return (p.id === inputID && p.nen === nen)
      })
      if (setplayer) this.setRecord(setplayer)
    },
    nameSlice (str) {
      const target = str.indexOf('/')
      if (target < 0) return {name: str, year: '0'}
      return {name: str.substring(0, target), year: str.substring(target + 1)}
    },
    setName (inputName) {
      function Spacecut (str) {
        return str.replace(' ', '').replace('　', '').replace('.', '')
      }
      if (inputName === '') return this.RandNameSet()
      let target = {name: inputName, year: 0}
      if (this.Yearcheck === 'y')target = this.nameSlice(inputName)
      target.name = Spacecut(target.name)
      var setplayers = this.users.filter((p) => {
        return (Spacecut(p.r_name) === target.name)
      })
      let setplayer
      if (setplayers.length === 1) {
        setplayer = setplayers[0]
      } else if (setplayers.length >= 2) {
        setplayer = setplayers.find(p => (this.Yearcheck !== 'y' || Number(p.nen) === Number(target.year)))
      } else {
        setplayer = this.users.find((p) => {
          return (Spacecut(p.r_name).indexOf(target.name.replace('　', ' ')) > -1)
        })
      }
      if (setplayer) {
        this.setRecord(setplayer)
      }
    },
    selectHand (h) {
      const handlist = this.InputHandList
      const rhand = handlist.find(hand => {
        if (h.indexOf(hand) > -1) return hand
      })
      if (rhand) return rhand
      return handlist[0]
    },
    setRecord (p) {
      let record = this.record
      Object.keys(p).some((rec) => {
        if (rec in this.record) {
          record[rec] = p[rec] * (this.InputRecordList.indexOf(rec) > -1 || this.InputProfile.indexOf(rec) > -1)
        }
      })
      record.hand = this.selectHand(p.hand)
      this.$store.dispatch('setValue', {vals: record, keyname: 'record'})
      this.$store.dispatch('setValue', {vals: p['r_name'] + (this.Yearcheck === 'y' ? '/' + p.nen : ''), keyname: 'playername'})
      this.setPosition(p)
    },
    posSet (def) {
      let poscount = {
        '投': 0,
        '捕': 0,
        '一': 0,
        '二': 0,
        '三': 0,
        '遊': 0,
        '外': 0,
        '指': 0
      }
      if (def === '' || def === 0) return poscount
      let dlist = def.replace(/(\D)(\d+)/g, '$1$2,').split(',').slice(0, -1)
      dlist.some(pos => {
        poscount[pos[0]] = Number(pos.replace(/[^0-9]/g, ''))
      })
      return poscount
    },
    setPosition (player) {
      var selects = []
      if (this.PosNumFlag) {
        this.$store.dispatch('setValue', {vals: this.posSet(player.DEF), keyname: 'inputedPoss'})
      } else {
        this.PosList.some((p, index) => {
          selects[index] = (player.DEF.indexOf(p) > -1)
        })
        this.$store.dispatch('setValue', {vals: selects, keyname: 'selectedPoss'})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/utility.js